<template>
  <div v-show="!interactionMeta.isInteractionAnswered && (!isLiveSession || (isLiveSession && !interactionMeta.pastSessionTime))">
    <v-btn
      id="interactionSubmitButton"
      :small="sidebarStyle === 'portrait' || smallScreen"
      color="primary"
      :loading="interactionMeta.isProcessingData && !interactionMeta.isRetakeExplanation"
      @click.prevent="submit"
      :disabled="interactionMeta.isProcessingData || interactionMeta.isInteractionAnswered || interactionMeta.isAnswerEmpty || interactionMeta.isRecordingAudio"
      :dark="interactionMeta.darkMode"
    >
    Submit
    </v-btn>
  </div>
</template>

<script>
/* global _ */
/* global dataLayer  */

// Plugins / Libraries:
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

import _ from 'lodash';

export default {
  name: 'interaction-submit',
  data() {
    return {
      interactionContinueMenuRenderInterval: null,
    }
  },
  props: {
    interactionId : {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState('player', [
      'isLiveSession',
    ]),
    ...mapGetters('adaptive', [
      'adaptive_bulb',
      'nsf_id'
    ]),
    ...mapGetters('player', [
      'mobile',
      'user',
      'bulbAttempt',
      'displayTime',
      'sidebarStyle',
      'smallScreen',
      'hasInteractionSubmitContinuePlaybackFeature',
      'user',
    ]),
    interaction() {
      return this.$store.getters['interactions/interaction'](this.interactionId) || {};
    },
    interactionAttempt() {
      return this.$store.getters['interactions/interactionAttempt'](this.interactionId) || {};
    },
    interactionMeta() {
      return this.$store.getters['interactions/interactionMeta'](this.interactionId) || {};
    },
    interactionHasNoFeedback() {
      return this.interaction.interactionOptions.every(interactionOption => !interactionOption.feedback);
    },
    interactionHasNoAnswerHighlighting() {
      if (['free_response', 'poll_q'].includes(this.interaction.interactionType)) return true;
      return Boolean(_.get(this, 'interaction.config.hide_correct_answer_always', false));
    },
  },
  methods: {
    ...mapActions('interactions', [
      'submitAnswer',
    ]),
    ...mapMutations('interactions', [
      'setInteractionContinueButtonShouldBeHidden',
    ]),
    handleInteractionSubmissionContinuePlayback() {
      this.interactionContinueMenuRenderInterval = setInterval( () => {
        const meetsInteractionSubmissionContinuePlaybackRequirements = (
          this.user.userType === 'student'
          && this.bulbAttempt.id
          && this.interactionHasNoFeedback
          && this.interactionHasNoAnswerHighlighting
        );
        this.setInteractionContinueButtonShouldBeHidden(Boolean(meetsInteractionSubmissionContinuePlaybackRequirements));
        if (this.$parent.$refs.interactionContinueMenu) {
          clearInterval(this.interactionContinueMenuRenderInterval);
          if (meetsInteractionSubmissionContinuePlaybackRequirements) {
            this.$parent.$refs.interactionContinueMenu.primaryAction();
            setTimeout(() => {
              this.setInteractionContinueButtonShouldBeHidden(false);
            }, 1000);
          }
        }
      });
    },
    submit() {
      this.submitAnswer({
        interaction: this.interaction,
        interactionAttempt: this.interactionAttempt,
        interactionMeta: this.interactionMeta
      });
      if (this.hasInteractionSubmitContinuePlaybackFeature) this.handleInteractionSubmissionContinuePlayback();
    },
  },
};
</script>

<style>

</style>
